import { Button } from '@octopus-do/octopus-storybook'
import { useEffect, useRef, useState } from 'react'

import API from '@/api'
import {
  ERROR_INVALID_PLAN,
  ERROR_LIMIT_REACHED,
  ERROR_TYPES,
  ERROR_USER_NOT_FOUND,
} from '@/constants/constants'
import { assert } from '@/helpers'
import Recaptcha from '../../RecaptchaWidget'
import styles from './TransferProject.module.css'

export const TransferProject = ({ id, closeButton }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [errorState, setErrorState] = useState(null)
  const [inputState, setInputState] = useState({
    value: '',
    isValid: false,
  })
  const inputRef = useRef(null)

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }, [inputRef])

  function onInputChange({ target }) {
    setErrorState(null)

    const { value } = target
    setInputState((prev) => {
      const isValid = assert.emailAddress(value)

      if (isValid === prev.isValid) {
        return { ...prev, value }
      }
      return { ...prev, value, isValid }
    })
  }

  function onSubmit(e) {
    e.preventDefault()
    setIsLoading(true)
    setErrorState(null)
    API.Projects.transfer({
      projectId: id,
      emailAddress: inputState.value,
    })
      .then(() => {
        window.location.reload()
      })
      .catch((err) => {
        setIsLoading(false)
        if (err.error !== undefined && ERROR_TYPES.includes(err.error)) {
          setErrorState(err.error)
        }
      })
  }

  return (
    <div className="Modal-content">
      <div className="Modal-header">
        <div className="Modal-heading">Transfer project</div>
        {closeButton}
      </div>
      <div className={styles.modalBody}>
        <div className={styles.modalText}>
          To initiate transfer please enter new owner's email address for
          confirmation email.
        </div>
        <Recaptcha>
          <form onSubmit={onSubmit}>
            <div>
              <div className={styles.containerRow}>
                <div className={styles.containerRowInput}>
                  <input
                    type="text"
                    ref={inputRef}
                    className="Clipboard-input"
                    name="emailAddress"
                    placeholder="E-mail"
                    defaultValue={inputState.value}
                    onChange={onInputChange}
                  />
                </div>
                <div>
                  <Button
                    type="submit"
                    label="Send"
                    loading={isLoading}
                    disabled={!inputState.isValid}
                  />
                </div>
              </div>
              {errorState === ERROR_USER_NOT_FOUND && (
                <div className={styles.formError}>
                  No user exists with such email
                </div>
              )}
              {errorState === ERROR_INVALID_PLAN && (
                <div className={styles.formError}>
                  You can transfer project to user with account plan PRO or
                  higher
                </div>
              )}
              {errorState === ERROR_LIMIT_REACHED && (
                <div className={styles.formError}>
                  User with such email has reached the project limit
                </div>
              )}
            </div>
          </form>
        </Recaptcha>
      </div>
    </div>
  )
}
